import { action, computed, makeAutoObservable, makeObservable, observable, runInAction } from "mobx";
import { ApplicationSdk } from "../..";

/**
 * The details of the categories
 */
class CategoryDetailStore {
    private sdk: ApplicationSdk;

    public newCategory: string = '';
    public categoryQuickSearch: string = '';

    // public order_id: number | null = null;
    public categoryNewLoading: boolean = false;
    public categoryDataLoading: boolean = false;
    public categoryDeleteLoading: boolean = false;

    // public orderData: any = null;
    public categories: Array<any> = [];

    constructor(sdk: ApplicationSdk) {
        makeObservable(this, {
            newCategory: observable,
            categoryQuickSearch: observable,
            categoryNewLoading: observable,
            categoryDataLoading: observable,
            categoryDeleteLoading: observable,
            categories: observable,
            newCategoryName: computed,
            quickSearch: computed,
            allCategories: computed,
            init: action,
            createNewCategory: action,
            deleteCategory: action,
            fetchCategories: action
        });
        this.sdk = sdk;

    }

    public async init(config: any): Promise<void> {
        // this.order_id = config.order_id;
        this.fetchCategories();
    }

    public async createNewCategory(): Promise<any> {
        runInAction(() => {
            this.categoryNewLoading = true;
        });
        const createCategory: any = await this.sdk.fetchApi(
            'category',
            'add',
            {
                name: this.newCategory
            }
        );

        runInAction(() => {
            this.categoryNewLoading = false;
            if (createCategory?.status === 201) {
                this.newCategory = '';
                this.fetchCategories();
            } else {
                throw new Error(createCategory?.json?.error || 'Unknown error');
            }
        });
    }

    public async deleteCategory(category_id: number): Promise<void> {
        runInAction(() => {
            this.categoryDeleteLoading = true;
        });

        const rmCategory: any = await this.sdk.fetchApi(
            'category',
            'delete',
            {
                category_id
            }
        );
        runInAction(() => {
            this.categoryDeleteLoading = false;
            if (rmCategory?.status === 200) {
                this.newCategory = '';
                this.categories = this.categories.filter((category: any) => category.id !== category_id);
            }
        });
    }

    public async fetchCategories(): Promise<void> {
        runInAction(() => {
            this.categoryDataLoading = true;
        })

        const categoryDetails: any = await this.sdk.fetchApi(
            'category',
            'query'
        );

        runInAction(() => {
            this.categoryDataLoading = false;

            if (categoryDetails?.status === 200) {
                this.categories = this.sdk.categories.update(
                    categoryDetails.json.categories,
                    categoryDetails.json.category_cache
                )
            }
        });
    }

    set newCategoryName(name: string) {
        runInAction(() => {
            this.newCategory = name;
        })
    }

    get newCategoryName(): string {
        return this.newCategory;
    }

    set quickSearch(name: string) {
        runInAction(() => {
            this.categoryQuickSearch = name;
        });
    }

    get quickSearch(): string {
        return this.categoryQuickSearch;
    }

    get id(): string {
        return 'category';
    }

    get allCategories(): any {
        return this.categories.filter((category: any) => {
            return category.name.toLowerCase().includes(this.categoryQuickSearch.toLowerCase());
        });
    }
}

export default CategoryDetailStore;